import { Button } from "./shadcn/button";
import { Link } from "./shadcn/link";
import notFound from "./404-notfound.jpg";

export const NotFoundView = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center min-h-[100dvh] gap-4">
      <img src={notFound} alt="Not Found" className="w-80 object-contain" />
      <div className="flex flex-col items-center justify-center text-center gap-2">
        <h1 className="text-2xl font-bold">Page not found</h1>
        <p className="text-xl"> The page you are looking for does not exist.</p>
      </div>
      <Button asChild className="w-auto px-6 py-3 mt-4">
        <Link to="/" className="no-underline">
          Go to Homepage
        </Link>
      </Button>
    </div>
  );
};
